import { Chip, Flex, Link, SelectCard } from '@servicetitan/anvil2';
import { card, wrapper } from './ProviderSelection.module.scss';
import { useProviderPreferences } from './useProviderPreference';
import { ProviderAndLogo } from './ProviderAndLogo';
import { useState } from 'react';
import { useBreakpoint } from '@servicetitan/financing-utils-shared';
import { SetupData, SetupDataStore } from '@servicetitan/financing-workflow-shared';

export const ProviderSelection = () => {
    const { enabledProviders, preferredProvider } = useProviderPreferences();
    const { setupData, setSetupData } = SetupDataStore.useStore();
    const { isXs } = useBreakpoint();
    const [showAll, setShowAll] = useState(false);
    const visibleProviders = isXs && !showAll ? enabledProviders?.slice(0, 3) : enabledProviders;
    const showOverflowButton = isXs && enabledProviders.length > 3;

    const setProvider = (provider: string) => {
        setSetupData((prev: SetupData) => ({
            ...prev!,
            provider,

            // Clear any pre-approval data when switching provider so that switching away from GreenSky (and
            // back) doesn't leave a stale preApprovalId that would route the next plan to the hard app.
            preApprovalId: undefined,
        }));
    };
    const provider = setupData?.provider;

    return (
        <Flex direction="column" gap="2">
            <SelectCard.Group
                legend="Provider"
                required
                selectionMode="single"
                value={provider ? [provider] : []}
                onChange={(_e, state) => {
                    if (state?.checked && state?.id != null) {
                        setProvider(String(state.id));
                    }
                }}
            >
                <Flex direction="column" wrap="wrap" gap="4" sm={{ direction: 'row' }}>
                    {visibleProviders.map(p => (
                        <SelectCard
                            key={p}
                            id={p!}
                            className={card}
                            radioProps={{ className: wrapper }}
                        >
                            <Flex
                                gap="2"
                                grow={1}
                                justifyContent="space-between"
                                alignItems="center"
                                style={{ width: '100%' }}
                            >
                                {isXs ? (
                                    <ProviderAndLogo
                                        provider={p}
                                        showPreferredProviderChip={preferredProvider === p}
                                    />
                                ) : (
                                    <>
                                        <Flex direction="column" gap="2" alignItems="baseline">
                                            <ProviderAndLogo provider={p} />
                                        </Flex>
                                        {preferredProvider === p && (
                                            <Chip
                                                label="Preferred"
                                                style={{ alignSelf: 'flex-start' }}
                                            />
                                        )}
                                    </>
                                )}
                            </Flex>
                        </SelectCard>
                    ))}
                </Flex>
            </SelectCard.Group>
            {showOverflowButton && (
                <Link
                    ghost
                    onClick={() => setShowAll(!showAll)}
                    alignSelf="center"
                    style={{ paddingTop: '8px' }}
                >
                    {showAll ? 'Show less providers' : 'Show more providers'}
                </Link>
            )}
        </Flex>
    );
};
